import React, {useEffect, useRef} from "react";
import {
  MenuItemBtn,
  ToggleBtnPanel,
  SidebarItemBlock,
  ImgIconWrapper,
  SidebarInfoStyle,
} from "./styles";
import {Sidebar as ProSidebar, Menu} from "react-pro-sidebar";
import MailIcon from "../../assets/icons/mail.svg";
import IconOpenPanel from "../../assets/icons/resize-out.svg";
import IconClosePanel from "../../assets/icons/resize-in.svg";
import {Tooltip} from "react-tooltip";
import {MENU_ITEMS} from "./dataSidebar";
import {IDataForSearchSidebar, ITypeRadar} from "../../types";
import {SidebarCardContainer} from "../../ui/SidebarCardContainer";
import {SidebarCardSearch} from "../SidebarCard/SidebarCardSearch/SidebarCardSearch";
import {SidebarCardSearchClusters} from "../SidebarCard/SidebarCardSearch/SidebarCardSearchClusters";
import {SidebarCardSearchTechnologies} from "../SidebarCard/SidebarCardSearch/SidebarCardSearchTechologies";
import {SidebarCardSearchEsg} from "../SidebarCard/SidebarCardSearch/SidebarCardSearchEsg";
import {SidebarCardSearchFintech} from "../SidebarCard/SidebarCardSearch/SidebarCardSearchFintech";
import {SidebarCardSearchStateInitiative} from "../SidebarCard/SidebarCardSearch/SidebarCardSearchStateInitiative";
import {apiKeyDataTehnology, urlApiDataTehnology} from "../../helper/api";
import useFetchDataTechClustersAll from "../../hooks/useFetchDataTechClustersAll";
import {SidebarFilters} from "../SidebarFilters/SidebarFilters";
import {
  IFintechFilters,
  IFintechWeakSignalsFilters,
} from "../../pages/Fintech/FintechDashboard.type";
import {IdashboardFilters} from "../../pages/Dashboard/Dashboard.type";
import {IEsgFilters} from "../../pages/Esg/EsgDashboard.type";
import {
  IAuthority,
  IStateInitiativeFilters,
} from "../../pages/StateInitiative/StateInitiative.type";
import {SidebarSearchContainer} from "../SidebarSearch/SidebarSearchContainer";
import SidebarSearch from "./SidebarSearch";
import {AuthPage} from "../../auth/AuthPage";
import {BtnAuth} from "./BtnAuth";
import {SidebarLogoBlock} from "./SidebarLogoBlock";
import StackholdersGray from "../../assets/icons/stackholders-gray.svg";

interface SidebarProps {
  setIsLogin?: React.Dispatch<React.SetStateAction<boolean>>;
  setRole?: React.Dispatch<React.SetStateAction<string | null>>;
  isLogin?: boolean;
  role?: string | null;
  activeTab: string;
  typeRadar: ITypeRadar;
  setIsOpenSideBarInfo: (value: boolean) => void;
  isOpenSideBarInfo: boolean;
  searchDatasidebarInfo?: IDataForSearchSidebar;
  setIsOpenPanel: React.Dispatch<React.SetStateAction<boolean>>;
  isOpenPanel: boolean;
  isOpenSideBar?: boolean;
  openSidebarWithTab: (
    tab: SidebarTab,
    directionId: number | string,
    clussterId?: number | string,
    name?: any,
    sectionName?: any,
    innerColor?: {back: string; color: string},
    nameTehnology?: string,
    idTehnology?: number | string,
    typeRadar?: ITypeRadar
  ) => void;
  setIsShowAllLabels: React.Dispatch<React.SetStateAction<boolean>>;
  isShowAllLabels: boolean;
  onCloseCard?: () => void;
  resetToDefaultTab?: () => void;
  onFilterChange: <T>(filter?: string, value?: T, isReset?: boolean) => void;
  filters:
    | IFintechFilters
    | IdashboardFilters
    | IEsgFilters
    | IStateInitiativeFilters;
  isVisibleFiltersPanel?: boolean;
  setIsVisibleFiltersPanel?: React.Dispatch<React.SetStateAction<boolean>>;
  filterWeakSignals?: IFintechWeakSignalsFilters;
  authorities?: IAuthority[];
  isActiveWorker?: boolean;
  isOpenSideBarStackHolders?: boolean;

  setIsOpenSearchPanel?: React.Dispatch<React.SetStateAction<boolean>>;

  isNationalProjects?: boolean;
  setIsNationalProjects?: React.Dispatch<React.SetStateAction<boolean>>;

  isBenefitsSubsidies?: boolean;
  setIsBenefitsSubsidies?: React.Dispatch<React.SetStateAction<boolean>>;

  isEditMode?: boolean;
  onToggleEditMode?: () => void;
  canEditPositions?: boolean;
}

export enum SidebarTab {
  Empty = "Empty",
  Directions = "Directions",
  Clusters = "Clusters",
  Projects = "Projects",
  StateOrganisations = "StateOrganisations",
  Trends = "Trends",
  Esg = "Esg",
  WeakSignal = "WeakSignal",
  Technologies = "Techonologies",
  StateInitiative = "stateInitiative",
  CPU = "CPU",
  Tags = "Tags",
  Navigation = "Navigation",
  Info = "Info",
  Metrics = "Metrics",
}

const Sidebar: React.FC<SidebarProps> = ({
  setIsLogin,
  setRole,
  isLogin,
  role,
  activeTab,
  typeRadar,
  setIsShowAllLabels,
  isShowAllLabels,
  setIsOpenSideBarInfo,
  isOpenSideBarInfo,
  isOpenSideBar,
  searchDatasidebarInfo,
  setIsOpenPanel,
  isOpenPanel,
  openSidebarWithTab,
  onCloseCard,
  resetToDefaultTab,
  onFilterChange,
  filters,
  isVisibleFiltersPanel,
  setIsVisibleFiltersPanel,
  authorities,
  isActiveWorker,
  isOpenSideBarStackHolders,

  isNationalProjects,
  setIsNationalProjects,

  isBenefitsSubsidies,
  setIsBenefitsSubsidies,

  isEditMode,
  onToggleEditMode,
  canEditPositions,

  setIsOpenSearchPanel: setIsOpenSearchPanelProp,
}) => {
  const [isOpenSearchPanel, setIsOpenSearchPanel] = React.useState(false);
  const [isOpenCardSearchDirections, setIsOpenCardSearchDirections] =
    React.useState(false);
  const [isOpenCardSearchClusters, setIsOpenCardSearchClusters] =
    React.useState(false);
  const [isOpenCardSearcTechnologies, setIsOpenCardSearchTechnologies] =
    React.useState(false);

  const [isOpenCardSearchEsg, setIsOpenCardSearchEsg] = React.useState(false);

  const [isOpenCardSearchFintech, setIsOpenCardSearchFintech] =
    React.useState(false);

  const [isOpenCardSearchStateInitiative, setIsOpenCardSearchStateInitiative] =
    React.useState(false);

  const apiUrlClusters = `${urlApiDataTehnology}/api/clusters`;

  const currentUrl = window.location.pathname;
  const isStackHoldersPage = currentUrl === "/crgci_organizations";
  const isStateInitiativePage = currentUrl === "/state_initiative";

  if (!apiKeyDataTehnology && !isStackHoldersPage && !isStateInitiativePage) {
    throw new Error("API key не тот");
  }

  const shouldLoadClusters =
    !isStackHoldersPage && !isStateInitiativePage && !!apiKeyDataTehnology;

  const {clusterData} = useFetchDataTechClustersAll(
    shouldLoadClusters ? apiUrlClusters : undefined,
    shouldLoadClusters ? apiKeyDataTehnology : undefined
  );

  const menuItemsIterator = MENU_ITEMS.get(typeRadar);
  const handleOpenSidebarInfo = () => {
    if (resetToDefaultTab) resetToDefaultTab();
    setIsOpenSideBarInfo(true);
    setIsOpenPanel(false);
    setIsOpenCardSearchDirections(false);
    setIsOpenCardSearchClusters(false);
    setIsOpenCardSearchTechnologies(false);
    setIsOpenCardSearchEsg(false);
    setIsOpenCardSearchFintech(false);
    setIsOpenCardSearchStateInitiative(false);
    setIsVisibleFiltersPanel?.(false);
  };

  const closeAllSidebarPanels = () => {
    setIsOpenSideBarInfo(false);
    setIsOpenCardSearchDirections(false);
    setIsOpenCardSearchClusters(false);
    setIsOpenCardSearchTechnologies(false);
    setIsOpenCardSearchEsg(false);
    setIsOpenCardSearchFintech(false);
    setIsOpenCardSearchStateInitiative(false);
    setIsVisibleFiltersPanel?.(false);
  };

  useEffect(() => {
    if (activeTab !== SidebarTab.Empty) closeAllSidebarPanels();
  }, [activeTab]);

  const handleOpenDirections = () => {
    if (resetToDefaultTab) resetToDefaultTab();
    setIsOpenSideBarInfo(false);
    setIsOpenCardSearchDirections(true);
    setIsOpenCardSearchClusters(false);
    setIsOpenCardSearchTechnologies(false);
    setIsOpenPanel(false);
    setIsVisibleFiltersPanel?.(false);
    setIsOpenSearchPanelProp?.(true);
  };
  const handleOpenClusters = () => {
    if (resetToDefaultTab) resetToDefaultTab();
    setIsOpenSideBarInfo(false);
    setIsOpenCardSearchDirections(false);
    setIsOpenCardSearchClusters(true);
    setIsOpenCardSearchTechnologies(false);
    setIsOpenPanel(false);
    setIsVisibleFiltersPanel?.(false);
    setIsOpenSearchPanelProp?.(true);
  };
  const handleOpenTechnologies = () => {
    if (resetToDefaultTab) resetToDefaultTab();
    setIsOpenSideBarInfo(false);
    setIsOpenCardSearchTechnologies(true);
    setIsOpenCardSearchDirections(false);
    setIsOpenCardSearchClusters(false);
    setIsOpenPanel(false);
    setIsVisibleFiltersPanel?.(false);
    setIsOpenSearchPanelProp?.(true);
  };

  const handleOpenEsg = () => {
    if (resetToDefaultTab) resetToDefaultTab();
    setIsOpenSideBarInfo(false);
    setIsOpenCardSearchEsg(true);
    setIsOpenPanel(false);
    setIsVisibleFiltersPanel?.(false);
  };

  const handleOpenFintech = () => {
    if (resetToDefaultTab) resetToDefaultTab();
    setIsOpenSideBarInfo(false);
    setIsOpenCardSearchFintech(true);
    setIsOpenPanel(false);
    setIsVisibleFiltersPanel?.(false);
  };

  const handleOpenStateInitiative = () => {
    if (resetToDefaultTab) resetToDefaultTab();
    setIsOpenSideBarInfo(false);
    setIsOpenCardSearchStateInitiative(true);
    setIsOpenPanel(false);
    setIsVisibleFiltersPanel?.(false);
  };

  const renderMenuItems = () => {
    let items = menuItemsIterator || [];

    if (isStackHoldersPage) {
      const stackHoldersItem = {
        icon: StackholdersGray,
        label: "stackHolders",
        tooltip: "СТЕЙКХОЛДЕРЫ",
        title: "Стейкхолдеры",
        width: 28,
        height: 28,
      };
      items = [...items, stackHoldersItem];
    }

    return (
      items &&
      items.map((item) => {
        return (
          <MenuItemBtn
            key={item.label}
            style={{
              cursor:
                item.label === "Directions" ||
                item.label === "stateInitiative" ||
                item.label === "stackHolders" ||
                item.label === "Info" ||
                item.label === "Trends" ||
                item.label === "Clusters" ||
                item.label === "CPU"
                  ? "pointer"
                  : "default",
            }}
            onClick={() =>
              item.label === "Info"
                ? handleOpenSidebarInfo()
                : item.label === "Directions" && typeRadar === "map"
                ? handleOpenDirections()
                : item.label === "Clusters"
                ? handleOpenClusters()
                : item.label === "CPU"
                ? handleOpenTechnologies()
                : item.label === "Directions" && typeRadar === "esg"
                ? handleOpenEsg()
                : item.label === "Trends"
                ? handleOpenFintech()
                : // : item.label === "Trends" && typeRadar === "weak_signals"
                // ? setIsOpenCardSearchFintech(true)
                item.label === "stateInitiative"
                ? handleOpenStateInitiative()
                : item.label === "stackHolders"
                ? () => {} // Здесь можно добавить обработчик для stackHolders
                : null
            }
            $isbtn={(item.label === "Info").toString()}
            $isactive={
              // (isOpenSideBarInfo && item.label === "Info") ||
              (
                (activeTab === item.label && isOpenSideBar) ||
                // (activeTab === item.label &&
                //   isOpenSideBar &&
                //   isActiveWorker === false) ||
                ("Directions" === item.label && isOpenCardSearchDirections) ||
                ("Clusters" === item.label && isOpenCardSearchClusters) ||
                ("CPU" === item.label && isOpenCardSearcTechnologies) ||
                ("stateInitiative" === item.label &&
                  isOpenCardSearchStateInitiative &&
                  !isOpenSideBarStackHolders) ||
                ("stackHolders" === item.label &&
                  ((!!isActiveWorker && !!isOpenSideBarStackHolders) ||
                    (isStackHoldersPage && !!isOpenSideBar)))
              ).toString()
            }
            $isblockvisible={isOpenPanel.toString()}
            $isopenpanel={isOpenPanel.toString()}
            data-tooltip-id={`tooltip-${item.label}`}
            data-tooltip-content={item.tooltip}
          >
            <ImgIconWrapper>
              <img
                src={item.icon}
                alt={item.label}
                width={item.width}
                height={item.height}
              />
            </ImgIconWrapper>
            <span>{item.title}</span>
            {!isOpenPanel && (
              <Tooltip
                id={`tooltip-${item.label}`}
                className="tooltip"
                place={"right"}
                noArrow
              />
            )}
          </MenuItemBtn>
        );
      })
    );
  };

  const sidebarRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target as Node)
      ) {
        setIsOpenPanel(false);
        setIsOpenSearchPanel(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [setIsOpenPanel]);

  return (
    <SidebarInfoStyle className="d-flex" ref={sidebarRef}>
      <div
        style={{width: isOpenPanel ? "350px" : "68px", transition: "all 0.3s"}}
        // collapsedWidth="60px"
        className="pro-sidebar"
        onClick={(event) => {
          if (event.target === event.currentTarget) {
            if (resetToDefaultTab) resetToDefaultTab();
            closeAllSidebarPanels();
            setIsOpenPanel((prev) => !prev);
            setIsOpenSideBarInfo(false);
          }
        }}
      >
        <SidebarLogoBlock isOpenPanel={isOpenPanel} />
        <Menu className="pro-sidebar-menu">
          <div className="d-flex flex-column" style={{gap: 8, width: "100%"}}>
            {typeRadar !== "stateInitiative" && (
              <SidebarSearch
                setIsOpenPanel={setIsOpenPanel}
                isOpenPanel={isOpenPanel}
                typeRadar={typeRadar}
                searchDatasidebarInfo={searchDatasidebarInfo}
                openSidebarWithTab={openSidebarWithTab}
                closeOpenSideBarInfo={() => setIsOpenSideBarInfo(false)}
                onCloseCard={onCloseCard}
                allClusters={clusterData?.data}
                setIsOpenSearchPanel={setIsOpenSearchPanel}
                setIsVisibleFiltersPanel={setIsVisibleFiltersPanel}
                resetToDefaultTab={resetToDefaultTab}
              />
            )}
            {typeRadar !== "stateInitiative" && renderMenuItems()}
            {!isStackHoldersPage && (
              <SidebarFilters
                onFilterChange={onFilterChange}
                isOpenPanel={isOpenPanel}
                filters={filters}
                typeRadar={typeRadar}
                isShowAllLabels={isShowAllLabels}
                setIsShowAllLabels={setIsShowAllLabels}
                isLogin={isLogin}
                role={role}
                onCloseOTherAllPanels={() => {
                  setIsOpenPanel(false);
                  setIsOpenSideBarInfo(false);
                  setIsOpenSearchPanel(false);
                  setIsOpenCardSearchDirections(false);
                  setIsOpenCardSearchClusters(false);
                  setIsOpenCardSearchTechnologies(false);
                  setIsOpenCardSearchEsg(false);
                  setIsOpenCardSearchFintech(false);
                  setIsOpenCardSearchStateInitiative(false);
                  resetToDefaultTab?.();
                }}
                isVisibleFiltersPanel={isVisibleFiltersPanel}
                setIsVisibleFiltersPanel={setIsVisibleFiltersPanel}
                authorities={authorities}
                isNationalProjects={isNationalProjects}
                setIsNationalProjects={setIsNationalProjects}
                isBenefitsSubsidies={isBenefitsSubsidies}
                setIsBenefitsSubsidies={setIsBenefitsSubsidies}
              />
            )}
          </div>
        </Menu>
        <SidebarItemBlock>
          <ToggleBtnPanel
            isactive={isOpenPanel.toString()}
            isrotateimg={isOpenPanel.toString()}
            data-tooltip-id={`settings`}
            data-tooltip-content={"ОТКРЫТЬ / СКРЫТЬ МЕНЮ"}
            onClick={(event) => {
              event.stopPropagation();
              if (resetToDefaultTab) resetToDefaultTab();
              closeAllSidebarPanels();
              setIsOpenPanel(!isOpenPanel);
              setIsOpenSideBarInfo(false);
              setIsVisibleFiltersPanel?.(false);
            }}
            addstyle={"padding-left:8px"}
          >
            <ImgIconWrapper>
              <img
                src={isOpenPanel ? IconClosePanel : IconOpenPanel}
                alt="Mail"
                width="15"
                height="15"
              />
            </ImgIconWrapper>
            <span>Скрыть меню</span>
            {!isOpenPanel && (
              <Tooltip
                id={"settings"}
                place="right"
                className="tooltip"
                noArrow
              />
            )}
          </ToggleBtnPanel>
          <ToggleBtnPanel
            isactive={isOpenPanel.toString()}
            data-tooltip-id={`settings`}
            data-tooltip-content={"СВЯЗЬ С РАЗРАБОТЧИКАМИ"}
            addstyle={"padding-left:8px"}
          >
            <ImgIconWrapper isrotate="true">
              <a
                href="mailto:sergey.vishnevskiy@gazprombank.ru"
                target="_blank"
                rel="noreferrer"
                style={{display: "flex", alignItems: "center"}}
              >
                <img src={MailIcon} alt="Mail" width="22" height="22" />
              </a>
            </ImgIconWrapper>
            <span>
              <a
                href="mailto:sergey.vishnevskiy@gazprombank.ru"
                target="_blank"
                rel="noreferrer"
                style={{color: "#fff", textDecoration: "none"}}
              >
                Тех. поддержка
              </a>
            </span>
            {!isOpenPanel && (
              <Tooltip
                id={"settings"}
                place="right"
                className="tooltip"
                noArrow
              />
            )}
          </ToggleBtnPanel>
          {typeRadar === "stateInitiative" && canEditPositions && (
            <ToggleBtnPanel
              isactive={isOpenPanel.toString()}
              data-tooltip-id="edit-mode"
              data-tooltip-content={
                isEditMode
                  ? "Выйти из режима редактирования"
                  : "Редактировать позиции точек"
              }
              addstyle={"padding-left:8px"}
              onClick={onToggleEditMode}
            >
              <ImgIconWrapper isrotate="true">
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="white"
                  strokeOpacity={isEditMode ? 1 : 0.6}
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                  <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                </svg>
              </ImgIconWrapper>
              <span style={{color: isEditMode ? "#11A0DA" : undefined}}>
                {isEditMode ? "Завершить" : "Редактировать"}
              </span>
              {!isOpenPanel && (
                <Tooltip
                  id="edit-mode"
                  place="right"
                  className="tooltip"
                  noArrow
                />
              )}
            </ToggleBtnPanel>
          )}
          {typeRadar === "stateInitiative" && (
            <BtnAuth
              setIsLogin={setIsLogin}
              setRole={setRole}
              isOpenPanel={isOpenPanel}
            />
          )}
        </SidebarItemBlock>

        {isOpenSearchPanel && (
          <SidebarSearchContainer
            setClosePanel={() => setIsOpenPanel(false)}
            onCloseSearchPanel={() => setIsOpenSearchPanel(false)}
            typeRadar={typeRadar}
            searchDatasidebarInfo={searchDatasidebarInfo}
            openSidebarWithTab={openSidebarWithTab}
            allClusters={clusterData?.data}
          />
        )}
      </div>

      <SidebarCardContainer isOpenSideBar={isOpenCardSearchDirections}>
        <SidebarCardSearch
          onCloseCard={() => {
            setIsOpenSearchPanelProp?.(false);
            setIsOpenCardSearchDirections(false);
          }}
          typeRadar={typeRadar}
          searchDatasidebarInfo={searchDatasidebarInfo}
          openSidebarWithTab={openSidebarWithTab}
        />
      </SidebarCardContainer>

      <SidebarCardContainer isOpenSideBar={isOpenCardSearchClusters}>
        <SidebarCardSearchClusters
          onCloseCard={() => {
            setIsOpenSearchPanelProp?.(false);
            setIsOpenCardSearchClusters(false);
          }}
          typeRadar={typeRadar}
          searchDatasidebarInfo={searchDatasidebarInfo}
          openSidebarWithTab={openSidebarWithTab}
          allClusters={clusterData?.data}
        />
      </SidebarCardContainer>

      <SidebarCardContainer isOpenSideBar={isOpenCardSearcTechnologies}>
        <SidebarCardSearchTechnologies
          onCloseCard={() => {
            setIsOpenSearchPanelProp?.(false);
            setIsOpenCardSearchTechnologies(false);
          }}
          typeRadar={typeRadar}
          searchDatasidebarInfo={searchDatasidebarInfo}
          openSidebarWithTab={openSidebarWithTab}
          allClusters={clusterData?.data}
        />
      </SidebarCardContainer>

      <SidebarCardContainer isOpenSideBar={isOpenCardSearchEsg}>
        <SidebarCardSearchEsg
          onCloseCard={() => setIsOpenCardSearchEsg(false)}
          typeRadar={typeRadar}
          searchDatasidebarInfo={searchDatasidebarInfo}
          openSidebarWithTab={openSidebarWithTab}
        />
      </SidebarCardContainer>

      <SidebarCardContainer isOpenSideBar={isOpenCardSearchFintech}>
        <SidebarCardSearchFintech
          onCloseCard={() => setIsOpenCardSearchFintech(false)}
          typeRadar={typeRadar}
          searchDatasidebarInfo={searchDatasidebarInfo}
          openSidebarWithTab={openSidebarWithTab}
        />
      </SidebarCardContainer>

      <SidebarCardContainer isOpenSideBar={isOpenCardSearchStateInitiative}>
        <SidebarCardSearchStateInitiative
          onCloseCard={() => setIsOpenCardSearchStateInitiative(false)}
          typeRadar={typeRadar}
          searchDatasidebarInfo={searchDatasidebarInfo}
          openSidebarWithTab={openSidebarWithTab}
        />
      </SidebarCardContainer>
    </SidebarInfoStyle>
  );
};

export default React.memo(Sidebar);
